import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, Validators } from "@angular/forms";
import { Helper } from "src/app/shared/Helper";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { ExcelModel } from "../../shared/models/geography";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";
import { StateModel } from "../../shared/models/state";
import { TemplateRef } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { StateProvider } from "../../shared/providers/state.provider";
import { RegionProvider } from "../../shared/providers/region.provider";
import { RegionModel } from "../../shared/models/region";
@Component({
  selector: "app-states",
  templateUrl: "./states.component.html",
  styleUrls: ["./states.component.scss"],
})
export class StatesComponent implements OnInit {
  addOrEditState: string;
  states: any = [];
  regions: RegionModel[];
  title = "modal2";
  formGroup;
  deletePopupUiData;
  excel: ExcelModel = new ExcelModel();
  tempOptionModel: any;
  pageNumber: any = 1;
  modalRef: BsModalRef;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private helper: Helper,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService,
    public adminDataProvider: AdminDataProvider,
    private toast: ToastClientService,
    private modalServiceNgx: BsModalService,
    public stateProvider: StateProvider,
    public regionProvider: RegionProvider
  ) {}

  ngOnInit() {
    // this.getAllRegions();
    this.getPageData(this.pageNumber);
  }

  ngDoCheck() {
    this.regions = this.regionProvider.regions;
  }

  productTree: any[];
  getPaginationCount;

  getPageData(pageNumber) {
    this.apiService
      .getHeaders(this.apiConfig.configGetStates + "?page=" + pageNumber)
      .subscribe(
        (res: any) => {
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
          this.states = res.body.data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  paginationClick(pageNumber) {
    this.getPageData(pageNumber);
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.formGroup.controls;
  }

  getAllRegions() {
    this.apiService.get(this.apiConfig.configGetRegion).subscribe(
      (res: any) => {
        this.regions = res.data.region;
        console.log("regions", this.regions);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  addState(targetModal) {
    this.addOrEditState = "add";
    this.formGroup = this.fb.group({
      state_name: ["", Validators.required],
      state_code: ["", Validators.required],
      region_id: ["", Validators.required],
      program_id: 1,
      parent_state_id: [""],
    });
    this.showStateModal(targetModal);
  }

  editState(targetModal, stateInfo) {
    this.addOrEditState = "edit";
    this.formGroup = this.fb.group({
      state_name: stateInfo.state_name,
      state_id: stateInfo.id,
      state_code: stateInfo.state_code,
      region_id: stateInfo.region_id,
      program_id: 1,
      parent_state_id: "",
    });

    this.showStateModal(targetModal);
  }

  deleteState(targetModal, stateInfo) {
    this.addOrEditState = "delete";
    this.deletePopupUiData = stateInfo.state_name;
    this.formGroup = this.fb.group({
      state_id: stateInfo.id,
      program_id: 1,
    });
    this.showStateModal(targetModal);
  }

  showStateModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  submitted = false;

  onSubmitState(formData) {
    this.submitted = true;

    // stop here if form is invalid
    if (this.formGroup.invalid) {
      return;
    }
    let apiUrl;
    if (this.addOrEditState == "add") {
      formData.parent_state_id = formData.state_code;
      apiUrl = this.apiConfig.configAddState;
    } else if (this.addOrEditState == "edit") {
      formData.parent_state_id = formData.state_code;
      apiUrl = this.apiConfig.configEditState;
    } else if (this.addOrEditState == "delete") {
      apiUrl = this.apiConfig.configDeleteState;
    }

    this.apiService.post(apiUrl, formData).subscribe(
      (res: any) => {
        console.log("successfully Added", res);
        this.stateActionSuccess(formData);
      },
      (err) => {
        console.log("err", err);
      }
    );
  }

  stateActionSuccess(data) {
    this.modalService.dismissAll();
    this.getPageData(this.pageNumber);
  }

  /**
   * @auth kailash_dev
   */
  /** Add new brands section */
  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel() {
    this.tempOptionModel.close();
  }
  uploadXlsx(eve) {
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }
  xlsxView(data) {
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.importAllUsers(this.excel);
        }
      },
      (reason) => {}
    );
  }

  importAllUsers(data) {
    this.apiService.post(this.apiConfig.importExcelState, data).subscribe(
      (res: any) => {
        this.toast.Success("Data imported Successfully");
        this.getPageData(this.pageNumber);
      },
      (err) => {
        this.toast.Error("Failed to Update");
        console.log(err);
      }
    );
  }

  downloadExcel() {
    this.exportExcelService.exportStateExcel(this.regions);
  }

  selectedState: StateModel;

  deleteStateData(data: StateModel, template: TemplateRef<any>) {
    this.selectedState = data;
    this.modalRef = this.modalServiceNgx.show(template, {
      class: "modal-sm",
      animated: false,
      backdrop: "static",
    });
  }

  confirm(): void {
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }
}
